import { render, staticRenderFns } from "./ViewIn3dButton.vue?vue&type=template&id=47d35d6e&scoped=true&"
var script = {}
import style0 from "./ViewIn3dButton.vue?vue&type=style&index=0&id=47d35d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d35d6e",
  null
  
)

export default component.exports